const stats = [
  { value: "+23%", label: "Rentabilidad" },
  { value: "+18%", label: "Productividad" },
  { value: "-43%", label: "Rotación voluntaria" },
  { value: "-81%", label: "Absentismo" },
];

export function ROI() {
  return (
    <section className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            El bienestar también es <br className="hidden sm:block" />
            <span className="text-gradient-brand">una decisión de negocio.</span>
          </h2>
        </div>
        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`relative overflow-hidden rounded-3xl border border-border p-8 shadow-soft ${
                i % 2 === 0 ? "bg-card" : "gradient-soft"
              }`}
            >
              <p className={`text-5xl font-semibold tracking-tight sm:text-6xl ${i % 2 === 0 ? "text-gradient-brand" : "text-foreground"}`}>
                {s.value}
              </p>
              <p className="mt-4 text-base font-medium text-foreground">{s.label}</p>
            </div>
          ))}
        </div>
        <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-muted-foreground">
          Comparación entre equipos con alto y bajo compromiso — Fuente: Gallup Q12 Meta-Analysis
        </p>
        <p className="mx-auto mt-8 max-w-2xl text-center text-lg text-muted-foreground">
          Los equipos con más nivel de compromiso generan <span className="font-medium text-foreground">mejores resultados sostenibles.</span>
        </p>
      </div>
    </section>
  );
}
